<template>
  <div>
    <div v-if="isEmptyObject(menu)">
      <div class="subtitle">Select a menu to edit or create a new menu</div>
      <div
        class="menu"
        v-for="menu in menus"
        v-bind:key="menu.id"
        v-on:click="selectMenu(menu)">
          <div class="menu-title">
            {{menu.name}}
          </div>
      </div>

      <div class="new-menu" v-on:click="selectMenu({})">
        <div class="menu-title">
          + Add a new menu
        </div>
      </div>
    </div>

    <div v-if="!isEmptyObject(menu)">
      <div class="back wide" v-on:click="goBack">
        Back to Menu Selection
      </div>
      <div class="menu-name">
        <input type="text" v-model="menu.name" placeholder="Menu Name">
      </div>

      <div
        v-for="(category, categoryIndex) in menu.categories"
        v-bind:key="category._id">
          <div class="category" v-bind:class="{slimCategory: editMode}">
            <input type="text" v-model="category.name" v-on:keyup.enter="saveCategory" maxlength="80">
          </div>

          <div class="delete-container" v-if="editMode" v-on:click="deleteCategory(categoryIndex)">
            <img src="../assets/images/trash-icon.svg" alt="Delete Item" />
          </div>

          <div class="position-container" v-if="editMode" v-on:click="moveCategory(categoryIndex, 'up')">
            <img src="../assets/images/up-icon.svg" alt="Move item up" />
          </div>

          <div class="position-container" v-if="editMode" v-on:click="moveCategory(categoryIndex, 'down')" >
            <img src="../assets/images/down-icon.svg" alt="Move item down" />
          </div>

          <div
            v-for="(product, productIndex) in category.products"
            v-bind:key="product.id">
              <div class="product" v-bind:class="{slimProduct: editMode}">
                <div class="product-name" v-bind:class="{fullName: editMode}">
                  <input type="text" v-model="product.name" maxlength="60">
                </div>
                <div class="product-price" v-if="!editMode">
                  <vue-numeric currency="$" separator="," v-model="product.price" v-bind:precision="2"></vue-numeric>
                </div>
                <div class="product-description">
                  <input type="text" class="description" v-model="product.description" placeholder="Enter your product's description (optional)" maxlength="120">
                </div>
              </div>

              <div class="delete-container delete-product" v-if="editMode" v-on:click="deleteProduct(categoryIndex, productIndex)" >
                <img src="../assets/images/trash-icon.svg" alt="Delete Item" />
              </div>

              <div class="position-container product-position" v-if="editMode" v-on:click="moveProduct(categoryIndex, productIndex, 'up')">
                <img src="../assets/images/up-icon.svg" alt="Move item up" />
              </div>

              <div class="position-container product-position" v-if="editMode" v-on:click="moveProduct(categoryIndex, productIndex, 'down')">
                <img src="../assets/images/down-icon.svg" alt="Move item down" />
              </div>
          </div>

          <div class="new-product" v-on:click="addNewProduct(category._id)">
            + Add a new product
          </div>
      </div>

      <div class="new-category" v-on:click="addNewCategory">
        + Add a new category
      </div>

      <div class="button edit" v-on:click="toggleEditor">
        {{this.editButtonText}}
      </div>

      <div class="button confirm" v-on:click="updateMenu">
        Save Menu
      </div>
    </div>
  </div>
</template>

<script>
import '../styles/base.css'
import arrayMove from 'array-move'
import Helpers from '../mixins/helpers.js'
import VueNumeric from 'vue-numeric'

export default {
  name: 'MenuBuilder',

  components: {
    Helpers,
    VueNumeric
  },

  data () {
    return {
      editMode: false,
      editButtonText: 'Edit Items',
      menu: {},
      menus: {}
    }
  },

  mixins: [Helpers],

  methods: {
    addNewCategory: function () {
      this.menu.categories.push({
        id: this.menu.categories.length + 1,
        name: 'Newly added category',
        position: this.menu.categories.length + 1,
        products: []
      })
    },

    addNewProduct: function (categoryId) {
      this.menu.categories.forEach(element => {
        if (element._id === categoryId) {
          element.products.push({
            name: 'Newly added product',
            position: element.products.length,
            price: 0
          })
        }
      })
    },

    deleteCategory: function (categoryIndex) {
      this.menu.categories.splice(categoryIndex, 1)
    },

    deleteProduct: function (categoryIndex, productIndex) {
      this.menu.categories[categoryIndex].products.splice(productIndex, 1)
    },

    getUserMenus: function () {
      this.axios.get('/api/menu/' + PS.user.organization_id).then((response) => {
        this.menus = response.data
        localStorage.setItem('menus', JSON.stringify(this.menus))
      }).catch((errors) => {
        localStorage.clear()
        this.$router.push('/login')
      })
    },

    goBack: function () {
      this.menu = {}
    },

    moveCategory: function (categoryIndex, direction) {
      let newIndex = (direction === 'up' && categoryIndex !== 0) ? categoryIndex - 1 : (direction === 'down' && (categoryIndex !== this.menu.categories.length - 1) ? categoryIndex + 1 : categoryIndex)
      let newCategoryOrder = arrayMove(this.menu.categories, categoryIndex, newIndex)

      this.menu.categories = newCategoryOrder
    },

    moveProduct: function (categoryIndex, productIndex, direction) {
      let newIndex = (direction === 'up' && productIndex !== 0) ? productIndex - 1 : (direction === 'down' && (productIndex !== this.menu.categories[categoryIndex].products.length - 1) ? productIndex + 1 : productIndex)
      let newProductOrder = arrayMove(this.menu.categories[categoryIndex].products, productIndex, newIndex)

      this.menu.categories[categoryIndex].products = newProductOrder
    },

    selectMenu: function (menu) {
      if (this.isEmptyObject(menu)) {
        this.menu = {
          categories: [],
          name: 'New Menu',
          user_id: ''
        }
      } else {
        this.menu = menu
      }
    },

    toggleEditor: function () {
      this.editMode = !this.editMode
      this.editMode ? this.editButtonText = 'Done Editing' : this.editButtonText = 'Edit Items'
    },

    updateMenu: function () {
      if (this.menu.organization_id === '') {
        this.menu.organization_id = PS.user.organization_id

        this.axios.post('/api/menu', this.menu).then((response) => {
          this.$parent.setCurrentMessage('Menu created successfully', false)
        }).catch((error) => {
          this.$parent.setCurrentMessage(error, true)
        })
      } else {
        this.axios.put('/api/menu/' + this.menu._id, this.menu).then((response) => {
          this.$parent.setCurrentMessage('Menu updated successfully', false)
        }).catch((error) => {
          this.$parent.setCurrentMessage(error, true)
        })
      }
    }
  },

  props: ['refresh'],

  watch: {
    refresh: function () {
      this.getUserMenus()
      this.$parent.refreshMenuList = false
    }
  }
}
</script>

<style scoped>
  .button {
    display: block;
    margin-top: 1em;
    padding: 1em;
  }

  .category, .new-category {
    background: white;
    color: #333333;
    border: 1px solid #e1e1e1;
    border-radius: 6px;
    height: 58px;
    margin-top: 1em;
    padding: 1em;
    width: 100%;
  }

  .confirm {
    background: var(--confirm);
  }

  .confirm:hover {
    background: var(--confirm-dark) !important;
  }

  .delete-container {
    display: inline-block;
    padding: .75em;
    position: relative;
  }

  .delete-product {
    bottom: 10px;
    position: relative;
  }

  .description {
    color: #737373;
    font-size: 14px !important;
  }

  .edit {
    background: var(--secondary);
  }

  .edit:hover, .edit:active {
    background: var(--secondary-dark);
  }

  .fullName {
    width: 100% !important;
  }

  input {
    background: none;
    border: none;
    font-size: 22px;
    height: 24px;
    width: 100%;
  }

  .menu, .new-menu {
    background: white;
    box-shadow: 0 1px 9px 1px rgba(39,39,39,.2);
    border-radius: 6px;
    cursor: pointer;
    display: inline-block;
    justify-content: space-around;
    margin: 1em;
    transition: all 0.25s ease-out;
    vertical-align: top;
    width: 288px;
  }

  .menu:hover, .new-menu:hover {
    transform: scale(1.1);
  }

  .menu-name {
    background: white;
    color: #333333;
    border: 1px solid #e1e1e1;
    border-radius: 6px;
    height: 58px;
    padding: 1em;
    width: 100%;
  }

  .menu-title {
    color: var(--dashboard-text);
    display: inline-block;
    padding: .75em;
    text-align: left;
  }

  .new-category {
    cursor: pointer;
  }

  .new-category:active {
    background: #d1d1d1;
  }

  .new-product {
    cursor: pointer;
    margin-top: 1em;
  }

  .new-product:active {
    background: #d1d1d1;
  }

  .position-container {
    display: inline-block;
    padding: .75em;
    position: relative;
  }

  .product, .new-product {
    background: white;
    color: #333333;
    border: 1px solid #e1e1e1;
    border-radius: 6px;
    margin: 1em 0 0 2em;
    padding: 1em;
    width: calc(100% - 2em);
  }

  .product-name {
    display: inline-block;
    width: calc(100% - 90px);
  }

  .product-position {
    bottom: 10px;
    position: relative;
  }

  .product-price {
    display: inline-block;
    width: 80px;
  }

  .right {
    text-align: right;
  }

  .slimCategory {
    display: inline-block;
    width: calc(100% - 150px);
  }

  .slimProduct {
    display: inline-block;
    width: calc(100% - 2em - 150px);
  }

  .subtitle {
    padding: 1em 0;
  }

  .wide {
    width: 175px;
  }
</style>
